export default "__VITE_ASSET__d3ca8186__"